import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../assets/config/config-svc.service';
import { SharedService } from '../shared/shared.service';
import { map} from 'rxjs/operators';
import { PositionAliasTo } from '../shared/models/positionAliasTo';


@Injectable({
    providedIn: 'root'
})
export class PositionAliasService {


    constructor(public http: HttpClient, 
                public sharedService: SharedService) {
    }

    getHeaders() {
        return this.getHeadersForContent('application/json', 'json')
    }

    getHeadersForContent(contentType, responseType) {
        const httpOptions = {
            headers: new HttpHeaders({
                'transactionId': this.sharedService.generateUUID(),
                'reportType': 'All'
            }),
            withCredentials: true,
            responseType: responseType
        };
        if (contentType) {
            httpOptions.headers.append('ContentType', contentType);
        }
        return httpOptions;
    }

    public createPositionAlias(payload: any) {
        return this.http.post(ConfigService.config.userServiceUrl + '/positionAlias/create', payload, this.getHeaders()).pipe(map((res: any) => res));
    }

    public updatePositionAlias(payload: any) {
        return this.http.put(ConfigService.config.userServiceUrl + '/positionAlias/update', payload, this.getHeaders()).pipe(map((res: any) => res));
    }

    public deletePositionAlias(positionAliasId: number) {
        return this.http.delete(ConfigService.config.userServiceUrl + '/positionAlias/' + positionAliasId, this.getHeaders()).pipe(map((res: any) => res));
    }

    public getPositionAliasList(clientId: string): Observable<PositionAliasTo[]> {
        return this.http.get<PositionAliasTo[]>(ConfigService.config.userServiceUrl + '/positionAlias?CLIENT_ID=' + clientId, this.getHeaders()).pipe(map((res: any) => this.setPositionAliasDataInModel(res)));
    }

    private setPositionAliasDataInModel(positionAliasData: any): PositionAliasTo[] {
        const positionAliasList: PositionAliasTo[] = [];
        if (positionAliasData) {
            positionAliasData.forEach(element => {
                const positionAlias = new PositionAliasTo(element);
                positionAliasList.push(positionAlias);
            });
        }
        return positionAliasList;
    }
}
